import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AteModalRef } from '@shared/services/ate-modal/ate-modal.ref';

@Component({
  selector: 'error-chunk-dialog',
  templateUrl: 'error-chunk-dialog.component.html',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ErrorChunkDialogComponent {
  private readonly _dialogRef = inject(AteModalRef<boolean>);

  constructor() {
    this._dialogRef.onCtaClick = () => this._dialogRef.close(true);
  }
}
